module.exports = __webpack_public_path__ + "img/telegram-1.7e776584.png";